module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-panel__scroll",
    attrs: {
      "id": "session-list-panel"
    }
  }, [(_vm.loading) ? _c('h2', {
    staticClass: "title error"
  }, [_vm._v("LOADING...")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('h2', {
    staticClass: "error"
  }, [_vm._v("SERVER FAKE ERROR: " + _vm._s(_vm.error) + " (Refresh until you get the sessions)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "session-list"
  }, _vm._l((_vm.sessions), function(session, index) {
    return _c('div', {
      staticClass: "session-list__item"
    }, [_c('div', {
      staticClass: "list-col--title"
    }, [_c('p', [_c('a', {
      on: {
        "click": function($event) {
          _vm.openSessionDetail(session.id)
        }
      }
    }, [_vm._v(_vm._s(session.title))])]), _vm._v(" "), _c('p', {
      staticClass: "related"
    }, [_vm._v(_vm._s(session.description))])]), _vm._v(" "), _c('div', {
      staticClass: "list-col--last-updated-on"
    }, [_c('p', [_c('span', {
      staticClass: "date",
      attrs: {
        "title": session.datetime
      }
    }, [_vm._v(_vm._s(session.datetime))])])]), _vm._v(" "), _c('div', {
      staticClass: "list-col--person"
    }, [_vm._v("\n          " + _vm._s(session.facilitator) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "list-col--place"
    }, [_vm._v("\n          " + _vm._s(session.place) + "\n        ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-panel__footer"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-panel__header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v("SESSIONS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd51a88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sessions.vue
// module id = 87
// module chunks = 1